import { observer } from 'mobx-react-lite';
import ProposalSection, { ProposalSectionEditableProps } from './ProposalSection';
import { ProposalDto } from '@gap/backend/app-services/proposal/models/ProposalDto';
import Typography from "@mui/material/Typography"
import { format as formatDate } from 'date-fns'

type ProposalSectionTimingProps = {
   proposal: ProposalDto,
   sectionProps?: ProposalSectionEditableProps,
}

export default observer(function ProposalSectionTiming({ proposal, sectionProps }: ProposalSectionTimingProps) {
   const { timing, duringMonth } = proposal.step4 || {}

   return (
      <ProposalSection heading="Timing" {...sectionProps}>
         <Typography variant="body1">
            We'll aim to start {
               (timing === 'during-a-given-month' && duringMonth) ?
                  `in ${formatDate(new Date(duringMonth), 'MMMM y')}`
                  : 'upon acceptance of this proposal'
            }.
         </Typography>
      </ProposalSection>
   )
})